import {styled} from "@mui/material/styles";
import {Badge, TableCell, tableCellClasses, TableRow} from "@mui/material";

export const infitineCardStyleSmall = {borderRadius: '0px', border: '0px solid #000'};
export const infitineCardStyle = { borderRadius: '0px',
    borderLeft: '0px solid #000',
    borderRight: '0px solid #000',
    borderBottom: '0px solid #000',};

export const StyledBadgeSmall = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -8,
        top: 1,
        lineHeight: 'inherit',
        padding: '0 4px',
        minWidth: '18px',
        height: '18px',
    },
}));

export const GrayStyledTableRow = styled(TableRow)(({ theme }) => ({
    '*': {
        fontSize: '1rem'
    },
    '&:nth-of-type(odd)': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderTop: '1px solid 1px solid #dee2e6'
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '*': {
        fontSize: '1rem'
    },
    '&:nth-of-type(odd)': {
        backgroundColor: '#a9b2dc',
        borderTop: '1px solid 1px solid #dee2e6'
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        borderTop: '1px solid #a9b2dc',
        backgroundColor: '#d1d6ec',
        fontWeight: 'bold',
        fontSize: '1rem',
        paddingLeft: '4px',
        paddingRight: '4px',
        //color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.head}:first-of-type`]: {
        paddingLeft: '8px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '1rem',
        paddingLeft: '4px',
        paddingRight: '4px',
    },
    [`&.${tableCellClasses.body}:first-of-type`]: {
        paddingLeft: '8px',
    },
}));